import { render, staticRenderFns } from "./CustomersAccounts.vue?vue&type=template&id=0a29783f&scoped=true"
import script from "./CustomersAccounts.vue?vue&type=script&lang=js"
export * from "./CustomersAccounts.vue?vue&type=script&lang=js"
import style0 from "./CustomersAccounts.vue?vue&type=style&index=0&id=0a29783f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a29783f",
  null
  
)

export default component.exports